export default "__VITE_ASSET__hbsSACCP__"